<template>
  <div>
    <organization-switcher
        v-if="newFilter && organizationId"
        class="mb-2"
        :pre-set-organization-id="organizationId"
        :org-selection-disabled="true"
        @setOrganization="id => localOrganizationId = id"
        @setTeam="id => teamId = id"
        @unsetTeam="teamId = ''"
    />

    <input
        v-if="newFilter"
        id="name"
        v-model="localName"
        :class="['form-text v-form-label form-text-dark mb-1', $v.name.$error ? 'form-group--error' : '']"
        :placeholder="$t('enternamehere')"
        type="text"
    >
    <div v-if="newFilter && !$v.name.required && $v.name.$error" class="form-error">{{ $t('errors.required') }}</div>
    <div v-if="newFilter && !$v.name.alphaNumSpace" class="form-error">{{ $t('errors.alphaNumSpaceOnly') }}</div>

    <div v-if="newFilter && !$v.name.maxLength" class="form-error">{{
        $t('errors.atMostCharacters', {num: 128})
      }}
    </div>

    <div v-if="newFilter && !$v.name.minLength" class="form-error">{{ $t('errors.atLeastCharacters', {num: 3}) }}</div>
    <div v-if="newFilter && !$v.name.isUnique" class="form-error">{{ $t('errors.sfxdataNameAlreadyExists') }}</div>
    <div v-if="error" class="form-error">{{ $t(error) }}</div>
    <div class="row">
      <div class="col-12 col-lg-6">
        <div class="inline-edit-label mt-3 vform-label white">
          <b>{{ $t('description') }}</b>
        </div>

        <textarea
            :id="'description'"
            v-model="description"
            :class="['mb-1 form-text v-form-label form-text-dark', $v.description.$error ? 'form-group--error' : '']"
            :placeholder="$t('enterdeschere')"
        />
        <div v-if="!$v.description.maxLength" class="form-error">{{ $t('errors.atMostCharacters', {num: 128}) }}</div>
      </div>
      <div class="col-12 col-md-6 mt-3">
        <team-attacher
            v-if="!newFilter && filterId !== 'new' && $store.getters.getFilterOrganization(filterId)"
            :id="filterId"
            slot="info"
            :collapsible="false"
            :limit-by-organization-id="$store.getters.getFilterOrganization(filterId)"
            :teams="teams"
            class="mt-3 mb-3 darker new-style bright"
            store-name="Asset"
            @added="loadAssetTeams"
            @removed="loadAssetTeams"
        />
        <tag-attacher
            v-if="!newFilter && filterId !== 'new' && $store.getters.getFilterOrganization(filterId)"
            :id="filterId"
            slot="info"
            :collapsible="false"
            :limit-by-organization-id="$store.getters.getFilterOrganization(filterId)"
            :tags="tags"
            class="mt-3 mb-3 darker new-style bright"
            store-name="Asset"
            @added="loadAssetTags"
            @removed="loadAssetTags"
        />
      </div>
    </div>
  </div>
</template>

<script>
import OrganizationSwitcher from "@/components/organizations/OrganizationSwitcher.vue";
import TeamAttacher from "@/components/organizations/TeamAttacher.vue";
import TagAttacher from "../organizations/TagAttacher.vue";
import {required, minLength, maxLength} from 'vuelidate/lib/validators';
import {alphaNumSpace} from "@/customValidators";
export default {
  name: "FilterBaseInfoEdit",
  components: {TeamAttacher, TagAttacher, OrganizationSwitcher},
  props: {
    name: {type: String, default: ''},
    organizationId: {type: String, default: ''},
    projectId: {type: String, default: ''},
    description: {type: String, default: ''},
    filterId: {type: String, default: ''},
    tags: {type: Array, default: () => []},
    teams: {type: Array, default: () => []},
  },
  validations: {
    name: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(127),
      alphaNumSpace,
      async isUnique(value) {
        // standalone validator ideally should not assume a field is required
        if (value === '') {
          return true;
        }
        let bool = true;
        await this.$store.dispatch('checkIfFilterNameExists', {type: 'Asset', name: value})
            .then(data => {
              bool = (data.length === 0 || (data[0].id === this.filterId));
            });
        return bool;
      },
    },
    description: {
      maxLength: maxLength(1024),
    },
  },
  data() {
    return {
      localOrganizationId: this.organizationId,
      teamId: '',
      error: '',
      localName: '',
    }
  },
  computed: {
    newFilter() {
      return this.filterId === 'new';
    },
  },
  watch: {
    localName(newVal) {
      this.$emit('updateName', newVal);
    },
    description(newVal) {
      this.$emit('updateDescription', newVal);
    },
    localOrganizationId(newVal) {
      this.$emit('updateOrganizationId', newVal);
    },
    teamId(newVal) {
      this.$emit('updateTeamId', newVal);
    },
  },
  beforeMount() {
    this.localName = this.name;
    if (this.filterId !== 'new') {
      this.loadAssetTeams();
      this.loadAssetTags();
    }
  },
  methods: {
    loadAssetTeams() {
      this.$emit('loadAssetTeams')
    },
    loadAssetTags() {
      console.log('emitting loadAssetTags')
      this.$emit('loadAssetTags')
    }
  }
}
</script>
